var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleDowninline = function SvgTriangleDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.753 10.887a1.068 1.068 0 0 1-1.509 0L2.98 6.623a1.062 1.062 0 0 1-.23-1.163c.167-.4.553-.66.987-.66h8.53a1.07 1.07 0 0 1 .756 1.823l-4.265 4.264h-.004Z",
    fill: "#7C7C7C"
  }))));
};
export default SvgTriangleDowninline;